require("@rails/ujs").start()
require("turbolinks").start()
import "bootstrap";
import '../info/styles/application.scss';
import '../info/scroll-and-spy';

import 'images/favicon.ico';
import 'images/apple-app-store-black.svg';
import 'images/qr-code-back-skaliert-apple.png';
import 'images/google-play-badge.png';
import 'images/qr-code-back-skaliert-google.png';
import 'images/muehlpfordt-small.jpg';

// import { library, dom } from '@fortawesome/fontawesome-svg-core'
// import {  faExternalLinkAlt, faBars } from '@fortawesome/free-solid-svg-icons'
// library.add(faExternalLinkAlt, faBars)
// dom.watch()
